module.exports = __webpack_public_path__ + "r-v3/img/drag.8cef90cb.svg";